import { render, staticRenderFns } from "./grid-legend.vue?vue&type=template&id=0d5ab09a&"
import script from "./grid-legend.vue?vue&type=script&lang=ts&"
export * from "./grid-legend.vue?vue&type=script&lang=ts&"
import style0 from "./grid-legend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports